<template>
  <ion-page>
    <ion-content
        color="light"
        :fullscreen="true"
        ref="content"
        :scroll-events="true"
        @ionScrollEnd="autoLoadMore"
        @ionScroll="handleScroll($event)"
    >
      <div class="page-content pb-0">
        <div class="card card-style bg-custom-2 w-100 mx-0 rounded-0 mb-0" style="height: 20vh;">
          <div class="page-content p-3 text-center">
<!--            <img src="@/assets/logo.png" style="height: 20vh;">-->
          </div>
        </div>
        <div class="card card-style rounded-2 bg-theme mx-0 pb-4 min-vh-100">
          <div class="content mt-2">
            <div class="row mb-1">
              <div class="col-12 pe-1 ps-1">
                <p class="font-20 color-theme d-block pt-2 text-start mb-0 color-black"><strong>ค้นหาเลขเด็ด</strong>
                </p>
                <p class="text-start color-black mb-0"><strong>{{ game?.name }}</strong></p>
                <ion-grid>
                  <ion-row>
                    <ion-col size="2">
                      <input
                          inputmode="numeric"
                          class="number-input"
                          placeholder="1"
                          id="number1"
                          ref="number1"
                          @keyup.delete="deleteNumber('number1','number1')"
                          @input="inputNumber('number1','number2');number1.number = $event.target.value[$event.target.value.length - 1]"
                          v-model="number1.number"
                      >
                    </ion-col>
                    <ion-col size="2">
                      <input
                          inputmode="numeric"
                          class="number-input"
                          placeholder="2"
                          id="number2"
                          ref="number2"
                          @keyup.delete="deleteNumber('number1','number2')"
                          @input="inputNumber('number2','number3');number2.number = $event.target.value[$event.target.value.length - 1]"
                          v-model="number2.number"
                      >
                    </ion-col>
                    <ion-col size="2">
                      <input
                          inputmode="numeric"
                          class="number-input"
                          placeholder="3"
                          id="number3"
                          ref="number3"
                          @keyup.delete="deleteNumber('number2','number3')"
                          @input="inputNumber('number3','number4');number3.number = $event.target.value[$event.target.value.length - 1]"
                          v-model="number3.number"
                      >
                    </ion-col>
                    <ion-col size="2">
                      <input
                          inputmode="numeric"
                          class="number-input"
                          placeholder="4"
                          id="number4"
                          ref="number4"
                          @keyup.delete="deleteNumber('number3','number4')"
                          @input="inputNumber('number4','number5');number4.number = $event.target.value[$event.target.value.length - 1]"
                          v-model="number4.number"
                      >
                    </ion-col>
                    <ion-col size="2">
                      <input
                          inputmode="numeric"
                          class="number-input"
                          placeholder="5"
                          id="number5"
                          ref="number5"
                          @keyup.delete="deleteNumber('number4','number5')"
                          @input="inputNumber('number5','number6');number5.number = $event.target.value[$event.target.value.length - 1]"
                          v-model="number5.number"
                      >
                    </ion-col>
                    <ion-col size="2">
                      <input inputmode="numeric"
                             type="number"
                             class="number-input"
                             placeholder="6"
                             id="number6"
                             ref="number6"
                             @keyup.delete="deleteNumber('number5','number6')"
                             @input="inputNumber('number6','number6');number6.number = $event.target.value[$event.target.value.length - 1]"
                             v-model="number6.number">
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </div>
            </div>
            <div class="row auto-grid" v-if="loadingState">
              <div class="col-6 col-md-4 col-lg-3 mb-3 pe-1 ps-1" v-for="i in 12" :key="i">
                <ion-thumbnail slot="start" class="w-100" style="height: 10vh;">
                  <ion-skeleton-text :animated="true"></ion-skeleton-text>
                </ion-thumbnail>
              </div>
            </div>
            <div class="row mb-5 auto-grid" data-masonry='{"percentPosition": true }'
                 v-else-if="lotteries_pack.length > 0">
              <div :class="index < lottery_to_show_1 ? 'col-6 col-md-4 col-lg-3 mb-3 pe-1 ps-1' : ''"
                   v-for="(lottery,index) in lotteries_pack"
                   :key="lottery.token"
              >
                <div class="card card-style m-0 rounded-bottom rounded-1 border-lottery"
                     v-if="index < lottery_to_show_1">
<!--                  <img :src="lottery.image[0]" @click="openImageViewer(lottery.image)">-->
                  <img :src="image" v-for="(image,index) in lottery.image" :key="index"
                       :class="index === 0 ? '' : 'margin-lotto-stack'"/>
                  <div class="card-center text-center color-white"
                       v-if="carts.filter((cart) => {return cart.token === lottery.token}).length > 0">
                    <i class="fa-solid fa-check-circle fa-fw fa-2x color-green-light"></i>
                    <p class="mb-0 color-green-light">เลือกแล้ว</p>
                    <button class="font-12 p-1 btn btn-danger rounded-2" @click="removeLottery(lottery)"><i
                        class="fa fa-fw fa-times me-2"></i>เอาออก
                    </button>
                  </div>
                  <img :src="`${assetAPI}/header/${lottery.count}.png`"
                       style="width: 30%;position: absolute">
                  <button @click="addLottery(lottery,index)" class="btn font-12 p-1 bg-btn-default rounded-top"><i
                      class="fa fa-fw fa-shopping-cart me-2"></i>เลือก
                  </button>
                  <div class="card-overlay bg-black opacity-70 rounded-1 text-center"
                       v-if="carts.filter((cart) => {return cart.token === lottery.token}).length > 0"
                  >

                  </div>
                </div>
              </div>
            </div>
            <div class="row text-center" v-else>
              <div class="col-12 mt-2">
                <div class="card card-style ion-text-center p-5">
                  <p><i class="fa fa-fw fa-times-circle fa-5x text-danger text-center"></i></p>
                  <h1>ไม่มีสลากวางจำหน่าย</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ion-button slot="fixed" @click="scrollToTop" v-if="btnToTop"><i class="fa fa-fw fa-arrow-up"></i></ion-button>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  loadingController,
  alertController,
  IonButton,
  IonSkeletonText,
  IonThumbnail, modalController
} from '@ionic/vue';
import {useRouter} from 'vue-router';
import Masonry from 'masonry-layout';
import Splide from "@splidejs/splide";
import ImageViewer from "@/components/ImageViewer.vue";

export default {
  name: 'StoreIndex',
  components: {
    IonPage,
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
    IonSkeletonText,
    IonThumbnail
  },
  data() {
    return {
      tab: 1,
      number1: {
        class: false,
        number: ""
      },
      number2: {
        class: false,
        number: ""
      },
      number3: {
        class: false,
        number: ""
      },
      number4: {
        class: false,
        number: ""
      },
      number5: {
        class: false,
        number: ""
      },
      number6: {
        class: false,
        number: ""
      },
      router: useRouter(),
      actionSheetButtons: [
        {
          text: 'Delete',
          role: 'destructive',
          data: {
            action: 'delete',
          },
        },
        {
          text: 'Share',
          data: {
            action: 'share',
          },
        },
        {
          text: 'Cancel',
          role: 'cancel',
          data: {
            action: 'cancel',
          },
        }
      ],
      lotteries: [],
      lotteries_pack: [],
      lotteries_alone: [],
      game: {},
      baseAPI: process.env.VUE_APP_BACKEND_BASE_URL,
      assetAPI: process.env.VUE_APP_BACKEND_ASSET_URL,
      loading: null,
      carts: [],
      lottery: {
        count: 1
      },
      lottery_count: 12,
      lottery_to_show_1: 12,
      lottery_to_show_2: 12,
      loadingState: true,
      btnToTop: false,
      searchBar: true,
      "languagePack": {
        "th": "ภาษาไทย",
        "lo": "ພາສາລາວ",
        "mm": "မြန်မာ",
        "en": "English"
      },
    }
  },
  ionViewWillEnter() {
    this.emitter.on('update-cart', async () => {
      await this.getCarts();
    });
    this.presentLoading().then(() => {
      setInterval(() => {
        try {
          const msnry = new Masonry('.auto-grid', {});
        } catch (e) {
          console.debug(e)
        }
      }, 500)
      this.getLottery();
      this.getCarts();
      this.emitter.on("back-home", () => {
        this.getLottery();
      })
      // new Splide('#single-slider-1', {
      //   type: 'loop',
      //   autoplay: true,
      //   interval: 4000,
      //   perPage: 1,
      // }).mount();
    })
  },
  methods: {
    handleScroll(ev) {
      this.btnToTop = ev.detail.scrollTop > 100;
    },
    async swapTab() {
      if (this.loadingState) {
        await this.presentLoading();
      }
      this.loadingState = true;
      await this.scrollToTop();
      if (this.tab === 1) {
        this.lotteries = this.lotteries_pack;
      } else {
        this.lotteries = this.lotteries_alone;
      }

      this.lottery_count = this.lotteries.length ?? 0;
      this.loading.dismiss()
      this.loadingState = false;
    },
    async search() {
      const num = `${this.number1.number}${this.number2.number}${this.number3.number}${this.number4.number}${this.number5.number}${this.number6.number}`;
      try {
        const response = await this.axios.post(`/lotteries/search`, {
          type: this.type,
          number: num,
          n1: this.number1.number,
          n2: this.number2.number,
          n3: this.number3.number,
          n4: this.number4.number,
          n5: this.number5.number,
          n6: this.number6.number,
          count: this.lottery.count
        });

        this.lotteries_pack = response.data.result.lotteries.pack ?? [];
        this.lotteries_alone = response.data.result.lotteries.alone ?? [];
        this.lottery_to_show_1 = response.data.result.count;
        this.lottery_to_show_2 = response.data.result.count;
        this.loadingState = false;
        await this.swapTab();
      } catch (error) {
        console.log(error)
      }
    },
    deleteNumber(focus, parent) {
      if (this.$refs[parent].value === "") {
        document.getElementById(focus).focus();
      }

      this.$refs[parent].value = "";
    },
    inputNumber(parent, focus = false, newValue = "") {
      parent = this.$refs[parent].value;
      if (parent.length >= 1) {
        parent = parent.slice(0, 1);
        parent = parent.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
        parent = parseInt(parent);
        if (focus) {
          document.getElementById(focus).focus();
        }

        this.loadingState = true;

        this.search();
        return newValue;
      }
    },
    async getLottery() {
      try {
        this.auth = await this.storage.get('auth');
        let response;
        if (this.auth) {
          response = await this.axios.get('/stores');
        } else {
          response = await this.axios.get('/lotteries/guest');
        }
        if (response.data.result.status === 0) {
          this.loading.dismiss();
          this.$router.push('reward');
          return;
        }
        this.lotteries_pack = response.data.result.lotteries.pack ?? [];
        this.lotteries_alone = response.data.result.lotteries.alone ?? [];
        this.lottery_to_show_1 = response.data.result.count;
        this.lottery_to_show_2 = response.data.result.count;
        this.lottery_count = this.lotteries_pack.length ?? 0;
        this.game = response.data.result.game;
        this.lotteries = this.lotteries_pack;
        this.loading.dismiss();
        this.loadingState = false;
      } catch (error) {
        if (error.response.status === 301) {
          this.loading.dismiss();
          this.$router.push(error.response.data.url)
        }
      }
    },
    async getCarts() {
      const carts = await this.storage.get('carts');
      if (carts) {
        this.carts = carts;
      } else {
        this.carts = [];
      }
    },
    async presentLoading() {
      this.loading = await loadingController.create({
        message: 'กรุณารอสักครู่',
        spinner: 'circles',
        mode: 'ios'
      })

      await this.loading.present();
    },
    async addLottery(lottery, index) {
      try {
        this.loading = await loadingController.create({
          message: 'กำลังจองสลากลงตะกร้า',
          spinner: 'circles',
          mode: 'ios'
        })

        await this.loading.present();

        if (this.carts.length + 1 > 20) {
          await this.loading.dismiss();
          const alert = await alertController.create({
            header: 'ถึงขีดจำกัด',
            message: 'ท่านสามารถเลือกสลากได้สูงสุด 20 ชุดต่อ 1 คำสั่งซื้อ',
            buttons: ['ตกลง'],
            mode: "ios"
          });

          await alert.present();
          return;
        }
        const response = await this.axios.post(`/lotteries/booking`, {
          token: lottery.token,
        });

        await this.loading.dismiss();

        if (response.data.code !== 0) {
          this.lotteries.splice(index, 1);
          const alert = await alertController.create({
            header: 'ขออภัยสลากที่ท่านเลือกมีคนซื้อแล้ว',
            message: `หมายเลข ${lottery.number} ถูกผู้อื่นซื้อไปแล้ว ระบบจะนำสลากนี้ออกจากตะกร้าของท่าน`,
            buttons: ['ตกลง'],
            mode: "ios"
          });

          await alert.present();
        } else if (response.data.code === 0) {
          await this.storage.set('cart_exp', response.data.exp);
          lottery.status = true;
          let carts = await this.storage.get('carts');
          carts = response.data.cart;

          await this.storage.set('carts', carts);
          this.carts = carts;
          this.emitter.emit('toggle-cart');
        }

      } catch (e) {
        await this.loading.dismiss();
        if (e.response.status === 401) {
          this.carts = [];
          this.storage.remove('carts');
          const alert = await alertController.create({
            header: 'กรุณาเข้าสู่ระบบ',
            message: 'เข้าสู่ระบบก่อนเพื่อดำเนินการต่อ',
            buttons: ['เข้าสู่ระบบ'],
            mode: "ios"
          });

          await alert.present();
          this.emitter.emit('toggle-cart');

          alert.onDidDismiss().then(() => {
            this.$router.push('/auth/login');
          });
        }
      }
    },
    async removeLottery(lottery) {
      const token = lottery.token;
      this.carts = this.carts.filter(lottery => {
        return lottery.token !== token
      });

      await this.storage.set('carts', JSON.parse(JSON.stringify(this.carts)));
      this.emitter.emit('toggle-cart');
      this.emitter.emit('update-cart');

      const response = await this.axios.post(`/lotteries/cancel_booking`, {
        full_number: lottery.number,
      });

    },
    autoLoadMore() {
      if (this.lottery_to_show_1 + this.lottery_to_show_2 > this.lottery_count) {
        this.lottery_to_show_1 = this.lottery_count;
      } else {
        this.lottery_to_show_1 += this.lottery_to_show_2;
      }
    },
    async scrollToTop() {
      await this.$refs.content.$el.scrollToTop(500);
    },
    async openImageViewer(images){
      const modal = await modalController.create({
        component: ImageViewer,
        componentProps: {
          images: images,
          title: "รูปสลาก"
        },
        initialBreakpoint: 1
      });

      await modal.present();

      const { data, role } = await modal.onWillDismiss();
    },
  }
}
</script>
<style scoped>
ion-card {
  --background: #FFF;
  --color: #000 !important;
  //border-radius: 10px !important;
}

ion-card-subtitle, ion-card-title {
  --color: #000;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
  -moz-appearance: textfield; /* Firefox */
}

.number-input {
  width: 13vw;
  height: 6vh;
  font-size: 1.5rem !important;
  text-align: center;
  border: 2px solid #05a851;
  border-radius: 12px;
  padding: 0 !important;
  background-color: #23c770;
  color: #fff !important;
}

.number-input::placeholder {
  font-weight: bold;
  opacity: 0.5;
  font-size: 1.5rem !important;
  color: white !important;
}

.card-style-custom {
  /*margin-top: -4vh;*/
}

.rounded-custom {
  border-radius: 20px 20px 0 0;
}

.bg-custom {
  background-color: #f4f5f8;
}

.margin-lotto-stack {
  margin-top: -40%;
}

.border-lottery {
  border: solid 0.5px #b0b0c5 !important;
}

ion-button[slot='fixed'] {
  bottom: 10vh;
  right: 0;
}

ion-toolbar {
  --background: white !important;
}
</style>
